const summary = [
  { label: "Payment state", value: "Partially paid", accent: true },
  { label: "Open exceptions", value: "2", accent: true },
  { label: "Last run", value: "14m ago", accent: false },
];

const AMBER = "oklch(var(--primary))";

const fieldRows = [
  {
    field: "payment_state",
    value: "Partially paid",
    evidence: "invoice_042.pdf + stripe_event_91",
    accent: true,
  },
  {
    field: "contract_status",
    value: "Active",
    evidence: "contract_master.pdf",
    accent: false,
  },
  {
    field: "open_exceptions",
    value: "2",
    evidence: "exception_policy",
    accent: true,
  },
  {
    field: "last_evidence",
    value: "invoice_042.pdf",
    evidence: "workflow run v2.3",
    accent: false,
  },
];

const DataProductVisual = () => (
  <div className="rounded-2xl border border-border bg-surface-panel overflow-hidden select-none w-full">

    {/* Header */}
    <div className="px-5 py-4 border-b border-border flex items-start justify-between gap-4">
      <div>
        <p className="font-mono text-[0.55rem] tracking-[0.14em] uppercase text-muted-foreground mb-1">
          Live record
        </p>
        <div className="flex items-baseline gap-2">
          <span className="font-serif font-semibold text-[0.95rem] tracking-[-0.01em] text-foreground">
            Payables record
          </span>
          <span className="font-mono text-[0.62rem] text-muted-foreground">
            Cloudflare
          </span>
        </div>
      </div>
      <div className="flex items-center gap-1.5 pt-1">
        <span className="w-1.5 h-1.5 rounded-full bg-[#16A34A]" />
        <span className="font-mono text-[0.62rem] text-muted-foreground">Current</span>
      </div>
    </div>

    {/* State summary */}
    <div className="px-5 py-4 border-b border-border">
      <p className="font-mono text-[0.58rem] tracking-[0.12em] uppercase text-muted-foreground mb-3">
        Current state
      </p>
      <div
        data-testid="live-record-summary-surface"
        className="grid divide-x divide-border rounded-xl border border-border overflow-hidden"
        style={{ gridTemplateColumns: "repeat(3, minmax(0, 1fr))" }}
      >
        {summary.map(({ label, value, accent }) => (
          <div key={label} className="px-3.5 py-3">
            <p className="font-mono text-[0.52rem] tracking-[0.08em] uppercase text-muted-foreground mb-1.5">
              {label}
            </p>
            <p
              className="font-mono text-[0.72rem] leading-tight"
              style={{ color: accent ? AMBER : "oklch(0.12 0.008 75)" }}
            >
              {value}
            </p>
          </div>
        ))}
      </div>
    </div>

    {/* Record fields */}
    <div className="px-5 py-4">
      <div className="overflow-x-auto rounded-xl border border-border bg-surface-panel overflow-hidden">
        <table
          aria-label="Cloudflare payables record fields"
          className="w-full min-w-[540px] border-collapse"
        >
          <thead>
            <tr className="border-b border-border" style={{ background: "oklch(0.94 0.006 75 / 0.45)" }}>
              <th scope="col" className="px-3.5 py-2.5 text-left font-mono text-[0.55rem] tracking-[0.1em] uppercase text-muted-foreground font-normal">
                Field
              </th>
              <th scope="col" className="px-3.5 py-2.5 text-left font-mono text-[0.55rem] tracking-[0.1em] uppercase text-muted-foreground font-normal">
                Current value
              </th>
              <th scope="col" className="px-3.5 py-2.5 text-left font-mono text-[0.55rem] tracking-[0.1em] uppercase text-muted-foreground font-normal">
                Evidence
              </th>
            </tr>
          </thead>
          <tbody>
            {fieldRows.map(({ field, value, evidence, accent }) => (
              <tr key={field} className="border-b border-border last:border-b-0">
                <td className="px-3.5 py-3 font-mono text-[0.62rem] text-muted-foreground">
                  {field}
                </td>
                <td
                  className="px-3.5 py-3 font-mono text-[0.62rem]"
                  style={{ color: accent ? AMBER : "oklch(0.12 0.008 75)" }}
                >
                  {value}
                </td>
                <td className="px-3.5 py-3 font-mono text-[0.6rem] text-muted-foreground">
                  {evidence}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    {/* Status */}
    <div
      className="px-5 py-3 border-t flex items-center justify-between gap-4"
      style={{ borderColor: "oklch(var(--primary) / 0.18)", background: "oklch(var(--primary) / 0.04)" }}
    >
      <span className="font-mono text-[0.6rem] text-muted-foreground">
        Evidence and workflow lineage attached.
      </span>
      <span className="font-mono text-[0.55rem] tracking-[0.1em] uppercase text-muted-foreground shrink-0">
        workflow v2.3
      </span>
    </div>

  </div>
);

export default DataProductVisual;
